import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import CmsBlock from '../../content/CmsBlock.js';

function PanelText({ panel }) {
    return (
        <Fragment>
            {(panel.blocks || []).map((subBlock, index) => <CmsBlock key={subBlock.id || index} block={subBlock} />)}
        </Fragment>
    );
}

PanelText.propTypes = {
    panel: PropTypes.object.isRequired,
};

export default PanelText;

